import { Component, OnInit } from '@angular/core';
import { DbService } from '../core/services/db.service';
import { ActivatedRoute } from '@angular/router';
import { Member } from '../core/models/member.models';
import { AlertService } from '../core/services/alert.service';

@Component({
  selector: 'app-user-modal',
  templateUrl: './user-modal.component.html',
  styleUrls: ['./user-modal.component.scss'],
})
export class UserModalComponent implements OnInit {
  uuid: Member['id'];
  member: Member;

  memo: string = '';

  constructor(private activatedRoute: ActivatedRoute, private db: DbService, private alertService: AlertService) {}

  ngOnInit(): void {
    // 상세 정보에 대한 uid값
    this.uuid = this.activatedRoute.snapshot.queryParams.id;

    this.getData();
  }

  // 상세 회원의 정보를 가져오기
  async getData() {
    this.member = await this.db.toDoc$(`members/${this.uuid}`);
    this.memo = this.member.memo;
  }

  // 회원 상태 체크
  checkActive(item: Member) {
    // 회원의 status로 상태를 반환하기
    if (item.status === 'exit') {
      return '탈퇴회원';
    }
    if (item.status === 'suspend') {
      return '정지회원';
    }
    return '활동회원';
  }

  // 가입 채널에 대한 형식을 한글로 변경하기
  displayName(loginType: string[]) {
    const mapping = {
      kakao: '카카오 (소셜)',
      apple: '애플 (소셜)',
      email: '이메일 (일반)',
    };

    return loginType?.map(item => mapping[item]).join(', ');
  }

  // 화면 닫기
  close() {
    window.close();
  }

  // 해당 회원의 기타 메모사항을 저장 처리
  async save() {
    await this.db.updateAt(`members/${this.uuid}`, {
      memo: this.memo,
    });
    this.alertService.swalToast('저장되었습니다.');
    this.getData();
  }
}
